/*
 *             Copyright (c) 2016 - 2022, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
'use strict';var __importDefault=this&&this['__importDefault']||function(_0xef6397){return _0xef6397&&_0xef6397['__esModule']?_0xef6397:{'default':_0xef6397};};Object['defineProperty'](exports,'__esModule',{'value':!0x0});const descriptor_1=__importDefault(require('./../../descriptor'));class SessionsSocketDescriptor extends descriptor_1['default']{}exports['default']=SessionsSocketDescriptor,SessionsSocketDescriptor['DESCRIPTOR_NAME']='SessionsSocketDescriptor',SessionsSocketDescriptor['DESCRIPTOR']={'fields':{'session':{'type':'string','id':0x1},'user':{'type':'string','id':0x2},'role':{'id':0x3,'type':'string'},'permissions':{'rule':'repeated','type':'string','id':0x4}}};